import axios from 'axios';
// console.log(process.env.REACT_APP_API_URL);

export default axios.create({
  baseURL: process.env.REACT_APP_API_URL
  // baseURL: `https://bykush-api.bykush-aggregator.xyz/api/v1`  //prod
  // baseURL: `https://bykush-api.stg-dmn.com/api/v1` //stag
  // baseURL: `http://192.168.1.59:5024/api/v1`
});
